import {
  TeamPersonPayload,
  WebSocketAction,
  WebSocketEntityType,
} from '@this+that/models';
import log from 'loglevel';

import type { IEventEmitter } from '../EventEmitter';
import { WebSocketEventType } from '../WebSocketContext';

export function createPersonMessageHandler(eventEmitter: IEventEmitter) {
  return (action: WebSocketAction, item: TeamPersonPayload) => {
    try {
      switch (action) {
        case WebSocketAction.INSERT:
          log.debug(`[PersonHandler] INSERT Person ${item.personId}`);
          eventEmitter.emit(
            WebSocketEntityType.Person,
            WebSocketEventType.INSERT,
            item,
          );
          break;
        case WebSocketAction.MODIFY:
          log.debug(`[PersonHandler] MODIFY Person ${item.personId}`);
          eventEmitter.emit(
            WebSocketEntityType.Person,
            WebSocketEventType.MODIFY,
            item,
          );
          break;
        case WebSocketAction.REMOVE:
          log.debug(`[PersonHandler] REMOVE Person ${item.personId}`);
          eventEmitter.emit(
            WebSocketEntityType.Person,
            WebSocketEventType.REMOVE,
            item,
          );
          break;
        default:
          log.debug('[PersonHandler] Ignoring action for Person:', action);
      }
    } catch (error) {
      log.error('[PersonHandler] Handler failed:', error);
    }
  };
}
